var exports = {
  "kL": "x31de4314--8eb115--container",
  "Qs": "x31de4314--8eb115--content",
  "Sl": "x31de4314--8eb115--image",
};

module.exports = exports;
